import {Injectable} from '@angular/core';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class CartDataUtil {
  constructor(private localStorageManager: LocalStorageManager) {}

  getCartData() {
    return this.localStorageManager.get('cartData') || [];
  }

  setCartData(data) {
    return this.localStorageManager.set('cartData', data);
  }

  removeProduct(productID: number) {
    this.setCartData(this.getCartData().filter(item => item.productID !== productID));
  }

  removeCartData() {
    this.localStorageManager.removeItem('cartData');
  }

  storeProduct(productID: string, queryID: string) {
    const cartData = this.getCartData();

    const existingEntry = cartData.find(
      item => item.productID === productID && item.queryID === queryID,
    );
    if (!existingEntry) {
      cartData.push({
        productID,
        queryID,
      });

      this.setCartData(cartData);
    }
  }
}
